import {
  OfferCreateMutationOptions,
  OfferDeleteMutationOptions,
  OfferUpdateMutationOptions,
  useOfferCreateMutation as useApolloOfferCreateMutation,
  useOfferDeleteMutation as useApolloOfferDeleteMutation,
  useOfferUpdateMutation as useApolloOfferUpdateMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useOfferCreateMutation = (baseOptions: OfferCreateMutationOptions) =>
  useMutation(useApolloOfferCreateMutation, baseOptions);

export const useOfferUpdateMutation = (baseOptions?: OfferUpdateMutationOptions) =>
  useMutation(useApolloOfferUpdateMutation, baseOptions);

export const useOfferDeleteMutation = (baseOptions?: OfferDeleteMutationOptions) =>
  useMutation(useApolloOfferDeleteMutation, baseOptions);
